/**
 * Normalizes a backend enum string to match config keys.
 * Lowercases only the first character — keeps camelCase intact.
 *
 * Used in RTK Query transformResponse to normalize enum fields
 * (cardStatus, type, etc.) at the API boundary, so the rest of the app
 * never depends on the backend's capitalization.
 *
 * @param {unknown} value - Raw value from the backend response
 * @returns {string | undefined} Normalized string, or undefined for invalid input
 *
 * @example
 * normalizeEnumKey('Active')          // → 'active'
 * normalizeEnumKey('active')          // → 'active'
 * normalizeEnumKey('Virtual')         // → 'virtual'
 * normalizeEnumKey('toActivate')      // → 'toActivate'
 * normalizeEnumKey('ToActivate')      // → 'toActivate'
 * normalizeEnumKey('MobilityBenefit') // → 'mobilityBenefit'
 * normalizeEnumKey(null)              // → undefined
 * normalizeEnumKey(undefined)         // → undefined
 * normalizeEnumKey('')                // → undefined
 * normalizeEnumKey(42)                // → undefined
 */
export const normalizeEnumKey = (value) => {
	if (!value || typeof value !== 'string') return undefined;
	return value.charAt(0).toLowerCase() + value.slice(1);
};
